import activeCollege from './active-college.json';

const collegeConfig = {
  // College Information — varies per college, see configs/<college>.json
  collegeName: activeCollege.collegeName,
  shortName: activeCollege.shortName,
  appName: "E-Logbook System",

  // Contact Information
  supportEmail: activeCollege.supportEmail,
  adminContact: activeCollege.adminContact,

  // Branding
  logo: require('../components/assets/logo.png'),
  favicon: '/favicon.ico',

  // Theme Colors — varies per college, see configs/<college>.json
  theme: activeCollege.theme,

  // Demo Videos (relative to /public — set to null to hide the Watch Demo button)
  demoVideos: {
    login:   '/assets/videos/login-demo.mp4',
    student: '/assets/videos/student-demo.mp4',
    teacher: '/assets/videos/prof-demo.mp4',
  },

  // App Store Links — varies per college, see configs/<college>.json
  appLinks: activeCollege.appLinks,

  // Feature flags
  features: {
    forgotPassword: true,
    rememberMe: false
  },

  // App Settings
  version: '1.2.0',
  copyrightYear: '2026',

  // API Endpoints
  api: {
    baseURL: process.env.REACT_APP_API_URL || activeCollege.apiBaseURL,
    timeout: 10000,
  },
};

// Export theme as CSS variables for easy use in CSS files
export const generateCSSVariables = () => {
  const variables = {};
  Object.entries(collegeConfig.theme).forEach(([key, value]) => {
    const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    variables[cssVarName] = value;
  });
  return variables;
};

export default collegeConfig;
